import { Component, OnInit } from '@angular/core';
import { NavigationService } from './modules/projeto-completo/services/navigation.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  constructor(public navigation: NavigationService) { }
  ngOnInit() {
  }
}
